import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import { AppBundle } from 'api/optimalprint-sdk.d';
import getDesignsFromFamilies from 'utils/family/getDesignsFromFamilies';
import { setOthersAlsoBoughtProductsAction } from '../slice';

// Studio selection top picks as the fallback if current category has no popular products.
const FALLBACK_CATEGORY_ID = 2942;

const fetchFamilies = async (categoryId: number, locale: string) => {
  const params = {
    categoryId,
    isMobile: false,
    offset: 0,
    limit: 12,
    sortBy: 6,
    locale,
  };

  return (await apiRequest(
    endpoints.categoryV3DesignsList,
    params,
    HttpMethods.GET,
    'data',
  )) as AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response;
};

const fetchOthersAlsoBoughtOperation =
  (categoryId: number) => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const { locale } = store.app;

    const { families } = await fetchFamilies(categoryId, locale);

    let designs = getDesignsFromFamilies(families);

    if (designs.length === 0) {
      const { families: fallbackFamilies } = await fetchFamilies(FALLBACK_CATEGORY_ID, locale);
      designs = getDesignsFromFamilies(fallbackFamilies);
    }

    dispatch(setOthersAlsoBoughtProductsAction(designs));
  };

export default fetchOthersAlsoBoughtOperation;
